/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import {fromJS} from 'immutable';

import {  Container, Table, Rating, Transition, Image, Header, Dimmer, Icon, Pagination, Statistic, Grid, Button, Loader, Feed, Popup, List, Card, Segment, Sidebar, Menu, Label } from 'semantic-ui-react'
import _ from 'lodash';
import moment from 'moment';

const defaultContainer = ({children}) => <div className="control-panel">{children}</div>;

export default class UserProfile extends PureComponent {

  state = {
    userisBanned: null,
    visible: false,
  }


  componentDidUpdate(prevProps) {
    console.log('did ypdate',this.props)
    if(this.state.visible == false && this.props.selectedUser !== null) {
      // console.log('then we have a new user selected that we need to show')
      this.setState({visible: true});
    }

    if(this.state.visible === true && this.props.selectedUser === null) {
      // console.log('then map unselected user somehow and we need to hide everything')
      this.setState({visible: false, userisBanned: false});
    }

    if(this.props.selectedUser && this.props.selectedUser.userId) {
      // then we are currently displaying a user
      if(!prevProps.selectedUser || (prevProps.selectedUser.userId !== this.props.selectedUser.userId)) {
        console.log('then we got a new user data to query');
        // Now query for user banned
        var db = this.props.firebase.database();
        var key = this.props.selectedUser.userId;

        var ref = db.ref('users/' + key + '/banned');

        ref.once("value", (snapshot) => {
          console.log('banned?',snapshot.val())
          // If user is is banned this will return true, if not it will be null or false
          this.setState({userisBanned: snapshot.val() === true ? true : false})
        })

      }
    }
  }

  _onSessionClick = (session) => {
    // const coordinates = [session.l[1],session.l[0]]
    this.props.onSessionClick(session);
  }
  _onClose = () => {
    this.setState({visible: false})
    this.props.updateState({selectedUser: null, activeFeatureId: null});
  }

  _toggleUserBan = () => {
      console.log('then toggle ban');
      // Now query for user banned
      var db = this.props.firebase.database();
      var key = this.props.selectedUser.userId;

      var ref = db.ref('users/' + key + '/banned');
      var newBanStatus = !this.state.userisBanned;

      ref.set(!this.state.userisBanned).then(error => {
        console.log('update userban callback error',error)
        if(error)
          alert('something went wrong trying to ban this user')
        // this very likely does not fire anything to re-render this user profile
        // so do that here.
        this.setState({userisBanned: !this.state.userisBanned})

      })


  }

  render() {
    const { selectedUser, activeFeatureId, loadingUserSessions, viewport, flyToUserSessions } = this.props;

    if(!selectedUser)
      return null


    const { visible } = this.state;

    return (
      <Transition animation={'fade'} duration={500} visible={visible}>
      <div style={{position: 'absolute', top: 40, right: 40, maxWidth: 300, maxHeight: '80%',}}>

      <Card color='yellow'>

      <Card.Content>

      <Header as='h1'><Header.Content>{visible && selectedUser.username}<Header.Subheader>{visible && selectedUser.userId}</Header.Subheader></Header.Content></Header>

      </Card.Content>


      <Card.Content>
      {
        this.state.userisBanned === null ?
        <Card.Content extra>Loading more user info</Card.Content>
        :
        this.state.userisBanned === true ?
        <Card.Content extra onClick={this._toggleUserBan} as='a' color='red'>This user is banned! (Click to unban)</Card.Content>
        :
        <Card.Content extra onClick={this._toggleUserBan} as='a'><Icon name='close' />Click to ban this user</Card.Content>
}
      </Card.Content>


      <Card.Content>

      <Card.Header>{visible && _.size(selectedUser.sessions)} Drawing{visible && _.size(selectedUser.sessions) > 1 && 's'}</Card.Header>
      <Menu vertical fluid>
      <Menu.Menu>
      {visible &&  _.map(selectedUser.sessions, (session,key) =>
        <Menu.Item as='a' name={''+key} active={activeFeatureId === key} key={key} onClick={ ()=> this._onSessionClick(session) }>

          <Card.Description><b>{session.properties.locale || session.properties.id}</b></Card.Description>
            <Card.Description>{moment(session.properties.timestamp).fromNow()}</Card.Description>

            <Card.Description>
              {_.times(session.properties.views,()=> <Icon key={Math.random()} name='eye' size='small' color={activeFeatureId === key ? 'yellow' : 'grey'} />)}
              </Card.Description>



        </Menu.Item>
      )}
      </Menu.Menu>
      </Menu>





      </Card.Content>

<Card.Content extra onClick={this._onClose} as='a'><Icon name='close' />Close</Card.Content>




  </Card>

      </div>
      </Transition>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/v3/user-profile.js